<template>
  <div class="page">
    <router-view />
    <van-tabbar route active-color="#c0dd2b" style="background-color: #1a1a1a">
      <van-tabbar-item to="/index" icon="home-o">
        <span>{{ $t('home') }}</span>
        <template #icon="props">
          <img :src="props.active ? icon.sy.active : icon.sy.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/news" icon="search"
        ><span>{{ $t('market') }}</span>
        <template #icon="props">
          <img :src="props.active ? icon.hq.active : icon.hq.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/fund" icon="friends-o">
        <span>{{ $t('aiquat') }}</span>
        <template #icon="props">
          <img :src="props.active ? icon.jy.active : icon.jy.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/assets" icon="setting-o">
        <span>{{ $t('assets') }}</span>
        <template #icon="props">
          <img
            :src="props.active ? icon.zc.active : icon.zc.inactive"
          /> </template
      ></van-tabbar-item>
      <van-tabbar-item @click="logout">
        <span>{{ $t('gxtk') }}</span>
        <template #icon="props">
          <img
            :src="props.active ? icon.sx.active : icon.sx.inactive"
          /> </template
        ></van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      icon: {
        sy: {
          active: require('../assets/img/icon_home1.5eb73990.svg'),
          inactive: require('../assets/img/icon_home.efc1304f.svg'),
        },
        hq: {
          active: require('../assets/img/icon_market1.5fc008d1.svg'),
          inactive: require('../assets/img/icon_market.1027b756.svg'),
        },
        jy: {
          active: require('../assets/img/icon_strategy1.c2229412.svg'),
          inactive: require('../assets/img/icon_strategy.de961571.svg'),
        },
        zc: {
          active: require('../assets/img/icon_account1.28bc5249.svg'),
          inactive: require('../assets/img/icon_account.191ff45f.svg'),
        },
        sx: {
          active: require('../assets/img/assets-dh.png'),
          inactive: require('../assets/img/assets-dh.png'),
        },
      },
    }
  },
  methods: {
    logout() {
      // const tokenstr = window.localStorage.getItem('token');
      // alert(window.localStorage.getItem('token') + '1111');
      window.localStorage.removeItem('token');
      // config.headers.Authorization = null;
      // alert(window.localStorage.getItem('token') + '2222');
      this.$router.push('/empty')
    },
  },
}
</script>
<style lang="less" scoped>
.page {
  background: #000;
}
/deep/ .van-hairline--top-bottom:after,
/deep/ .van-hairline-unset--top-bottom:after {
  border-width: 0;
}
.van-tabbar {
  height: 3.33333rem;
  background-color: #1a1a1a;
  //border-top: 0.02667rem solid #323a5e;
  z-index: 99;
  .van-tabbar-item {
    color: #fff;
  }
  .van-tabbar-item__icon {
    margin-top: 5px;
  }
  .van-tabbar-item__text {
    color: #c0dd2b;
  }
  .van-tabbar-item img {
    width: 1.6rem;
    height: 1.6rem;
  }
  .van-tabbar-item--active {
    color: #c0dd2b;
    background-color: #1a1a1a;
  }
  .van-hairline-unset--top-bottom::after {
    border-width: 0px 0;
  }
}
</style>
